/*
 * This file is part of the Akershus Eiendom Nettsted 2019 application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import PropTypes from 'prop-types';

/**
 * This is the Check component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function Check({ title }) {
  return (
    <span className="svg svg-check">
      <span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15.781"
          height="14.782"
          viewBox="0 0 15.781 14.782"
        >
          <title>{title}</title>
          <g transform="translate(-136.086 -1311.132)">
            <line
              x1="7"
              y2="12"
              transform="translate(143.5 1312.5)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeWidth="2"
            />
            <line
              x2="6"
              y2="6"
              transform="translate(137.5 1318.5)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeWidth="2"
            />
          </g>
        </svg>
      </span>
    </span>
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
Check.propTypes = {
  title: PropTypes.string,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
Check.defaultProps = {
  title: 'Check',
};

export default Check;
